import { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'src/store';
import { editCurrentIndex } from 'src/store/modules/imageUpload';

export const useSwiper = () => {
  const swiperRef = useRef<any>(null);
  const bgImage = useSelector(state => state.imageUpload.bgImage);
  const dispatch = useDispatch();
  const [isResourceLoaded, setIsResourceLoaded] = useState(false);
  const currentIndex = useSelector(state => state.imageUpload.currentIndex);
  const [swiperInstance, setSwiperInstance] = useState<any>(null);

  useEffect(() => {
    const loadExternalResources = async () => {
      await Promise.all([
        loadScript('https://unpkg.com/swiper@11/swiper-bundle.min.js'),
        loadStylesheet('https://unpkg.com/swiper@11/swiper-bundle.min.css')
      ]);
      setIsResourceLoaded(true);
    };

    loadExternalResources();
  }, []);

  useEffect(() => {
    if (swiperInstance && swiperInstance.realIndex !== currentIndex) {
      swiperInstance.slideTo(currentIndex);
    }
  }, [currentIndex, swiperInstance]);

  useEffect(() => {
    if (isResourceLoaded) {
      if (!swiperInstance) {
        const newSwiperInstance = initializeSwiper();
        setSwiperInstance(newSwiperInstance);
      } else {
        swiperInstance.update();
        swiperInstance.pagination.render();
        swiperInstance.pagination.update();
      }
    }
  }, [isResourceLoaded, bgImage, swiperInstance]);

  const initializeSwiper = () =>
    // @ts-ignore
    new window.Swiper(swiperRef.current, {
      slidesPerView: 1,
      loop: false,
      pagination: {
        el: '.swiper-pagination'
      },
      effect: 'slide',
      speed: 400,
      on: {
        slideChange: (swiper: any) => {
          const newIndex = swiper.realIndex;
          dispatch(editCurrentIndex(newIndex));
        }
      }
    });
  const loadScript = (src: string): Promise<void> =>
    new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = src;
      script.onload = () => resolve();
      script.onerror = () => reject();
      document.head.appendChild(script);
    });

  const loadStylesheet = (href: string): void => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    document.head.appendChild(link);
  };

  return { swiperRef };
};
